import React from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from '@material-ui/core/Grid';
import Typography from '../StorybookComponents/Typography';
import ErrorImage from '../images/404-image.svg';

const styles = theme => ({
  root: {
    ...theme.margin,
    [theme.breakpoints.up('md')]: {
      ...theme.marginBig,
    },
    marginTop:0
  },
  node: {
    background: theme.palette.white,
    padding:'40px'
  },
  flexShrink: {
    minWidth: 0,
    minHeight: 0,
    flexShrink: 1
  }
});

export function error_message(code) {
  switch(code) {
    case 401:
      return 'Access Denied';
    default: return 'Page not found';
  }
}

export function description(code) {
  switch(code) {
    case 401:
      return 'You do not have permissions to view this page';
    default: return 'We are working to fix this problem, please try again soon.';
  }
}

export default withStyles(styles)(({
  errors,
  isRoot,
  code = 404,
  classes: {
    root,
    node,
    flexShrink,
  }
}) => {

  const className = isRoot ? root : node;

  return (
    <Grid
      container
      direction = "column"
      alignItems = "center"
      justify = "center"
      className = {className}
    >
    <Grid item
      container
      direction = "row"
      justify = "center"
    >
        <Typography noWrap type = "h4" color = 'hylyBlue' >
        {code}
        </Typography>
        &nbsp;&nbsp;
        <Typography type = "body1">
          {error_message(code)}
        </Typography>
      </Grid>

      <Grid item>
        <img
          src = {ErrorImage}
          className = {flexShrink}
        />
      </Grid>

      <Grid item>
        <Typography color = "deepGrey" variant = "body1">
          {description(code)}
        </Typography>
      </Grid>

    </Grid>
  )
})
/*
Array.isArray(errors) ?
  errors.map(error => (
      <Typography
          variant = "subtitle1"
          key = {error.message}
          color = "textSecondary"
       >
        { error.message || error }
      </Typography>
    )
  ) :
  <Typography color = "textSecondary">
    { errors.message || errors }
  </Typography>
*/
